import React from 'react';
import { Dialog, DialogContent, DialogActions, Button, Typography, Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export default function ImageLightbox({ open, onClose, src, alt, caption }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg">
      <DialogActions sx={{ position: 'absolute', right: 8, top: 8 }}>
        <IconButton onClick={onClose}><CloseIcon /></IconButton>
      </DialogActions>
      <DialogContent sx={{ p: 0, bgcolor: 'black' }}>
        <Box component="img" src={src} alt={alt} sx={{ width: '100%', height: '70vh', objectFit: 'contain', bgcolor: 'black' }} />
      </DialogContent>
      {caption && (
        <Box sx={{ px: 3, py: 2 }}>
          <Typography variant="caption" color="text.secondary">{caption}</Typography>
        </Box>
      )}
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
